
<style scoped lang="scss">
.calendar-wra /deep/ {
    position: fixed;
    z-index: 30;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    width: 100vw;
    height: 100vh;
    background: $white;
    .calendar {
        td {
            height: 60px;
            &.week {
                color: #333;
                font-size: 13px;
                height: 30px;
                background: #f0f0f0;
                &:last-child,
                &:first-child {
                    color: $orange;
                }
            }
            &.selected {
                background: rgba(240, 187, 27, 0.2);
                span {
                    background-color: initial;
                    color: initial;
                }
            }
            span {
                font-size: 14px;
                font-weight: bold;
                padding-top: 20px;
                height: auto;
            }

            .text {
                color: $orange;
                font-size: 11px;
                top: 32px;
            }
        }
    }
    .date-wra {
        height: 1.56rem;
        width: 100%;
        padding: 0 0.88rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        box-shadow: 0px 5px 5px 0px rgba(0, 0, 0, 0.07);
        margin-bottom: 0.4rem;
        .al {
            font-size: 14px;
            color: #666666;

            .bold {
                margin-left: 0.306667rem;
                font-weight: bold;
                color: #484848;
                font-size: 14px;
            }
        }
        .mid {
            font-weight: bold;
            color: #484848;
            font-size: 12px;
        }
    }
}
</style>

<template>
    <transition name="fade">
        <div class="calendar-wra" v-show="isOpen">
            <div class="date-wra">
                <div class="al">
                    入住<span class="bold">{{ arrive }}</span>
                </div>
                <div class="mid">{{ duration }}晚</div>
                <div class="al">
                    离店<span class="bold">{{ leave }}</span>
                </div>
            </div>
            <calendar
                :zero="true"
                :range="calenderSettings.range"
                :begin="calenderSettings.begin"
                :value="initialValueArr"
                @select="select"
            ></calendar>
        </div>
    </transition>
</template>

<script>
import Calendar from "@/components/common/Calendar.vue";
export default {
    name: "SelectRangeDate",
    components: { Calendar },
    props: {
        arrive: String,
        leave: String,
        duration: [String, Number],
    },
    data() {
        return {
            isOpen: false,
            calenderSettings: {
                range: true,
                begin: moment().format("YYYY-MM-DD").split("-"),
            },
            initialValueArr: [
                moment().format("YYYY-MM-DD").split("-"),
                moment().add(1, "day").format("YYYY-MM-DD").split("-"),
            ],
        };
    },
    computed: {},
    watch: {},
    created() {},
    mounted() {},
    destroyed() {},
    methods: {
        select(begin, end) {
            if (begin.toString() === end.toString()) {
                this.$toast("入住天数至少为一天！");
                return;
            }
            this.$emit("confirm", {
                arriveDate: begin.join("-"),
                leaveDate: end.join("-"),
            });
            this.closeModal();
        },
        closeModal() {
            this.isOpen = false;
        },
        openModal() {
            this.isOpen = true;
        },
    },
};
</script>

